'use client';

import s from 'Bomdisoft/shared/legal-page-shell/styles.module.css';
import { PaintedTitle } from 'Bomdisoft/shared/painted-title';
import type { ReactNode } from 'react';

export type LegalPageShellProps = {
  children: ReactNode;
  eyebrow: string;
  lede: string;
  testId: string;
  title: string;
  titleAccent: string;
};

export const LegalPageShell = ({ children, eyebrow, lede, testId, title, titleAccent }: LegalPageShellProps) => (
  <div className={s.root} data-testid={testId}>
    <header className={s.hero}>
      <div className={s.heroInner}>
        <span className={s.heroEyebrow}>{eyebrow}</span>
        <h1 className={s.heroTitle}>
          <PaintedTitle text={title} /> <span className='grad'>{titleAccent}</span>
        </h1>
        <p className={s.heroLede}>{lede}</p>
      </div>
    </header>
    {children}
  </div>
);
